import { fsdb } from '../firebase'

let db = fsdb

export const getDb = () => db
export const setDb = (theDb) => {
  db = theDb
}
